import { hasProp } from "../../helpers/Class";
import Bookseller from "./Bookseller/Bookseller";
import DistributionAddress from "./DistributionAddress";
import i18n from "../../i18n";

class DistributionOrder {
    // eslint-disable-next-line max-lines-per-function
    constructor(order = null) {
        this._id = !hasProp(order, "_id") ? undefined : order._id;
        this.user = !hasProp(order, "user") ? new Bookseller() : new Bookseller(order.user);
        this.total = !hasProp(order, "total") ? undefined : order.total;
        this.totalWT = !hasProp(order, "totalWT") ? undefined : order.totalWT;
        this.currency = !hasProp(order, "currency") ? undefined : order.currency;
        this.reference = !hasProp(order, "reference") ? undefined : order.reference;
        this.status = {
            payment: !hasProp(order, "status.payment") ? undefined : order.status.payment,
            production: !hasProp(order, "status.production") ? undefined : order.status.production,
        };
        this.createdAt = !hasProp(order, "createdAt") ? undefined : order.createdAt;
        this.updatedAt = !hasProp(order, "updatedAt") ? undefined : order.updatedAt;
        this.billing = {
            to: !hasProp(order, "billing.to") ? undefined : order.billing.to,
            method: !hasProp(order, "billing.method") ? undefined : order.billing.method,
            address: !hasProp(order, "billing.address") ? new DistributionAddress() : new DistributionAddress(order.billing.address),
            EUVATReverseCharge: !hasProp(order, "billing.EUVATReverseCharge") ? undefined : order.billing.EUVATReverseCharge,
            reference: {
                proForma: !hasProp(order, "billing.reference.proForma") ? undefined : order.billing.reference.proForma,
                bill: !hasProp(order, "billing.reference.bill") ? undefined : order.billing.reference.bill,
                credit: !hasProp(order, "billing.reference.credit") ? undefined : order.billing.reference.credit,
            },
        };
        this.delivery = {
            to: !hasProp(order, "delivery.to") ? undefined : order.delivery.to,
            method: !hasProp(order, "delivery.method") ? undefined : order.delivery.method,
            address: !hasProp(order, "delivery.address") ? new DistributionAddress() : new DistributionAddress(order.delivery.address),
            price: !hasProp(order, "delivery.price") ? undefined : order.delivery.price,
            priceWT: !hasProp(order, "delivery.priceWT") ? undefined : order.delivery.priceWT,
            carrierId: !hasProp(order, "delivery.carrierId") ? undefined : order.delivery.carrierId,
            tax: {
                reduced: !hasProp(order, "delivery.tax.reduced") ? undefined : order.delivery.tax.reduced,
                percent: !hasProp(order, "delivery.tax.percent") ? undefined : order.delivery.tax.percent,
            },
            free: !hasProp(order, "delivery.free") ? undefined : order.delivery.free,
            sendingDate: !hasProp(order, "delivery.sendingDate") ? undefined : order.delivery.sendingDate,
        };
        this.productAmount = !hasProp(order, "productAmount") ? undefined : order.productAmount;
    }

    get productAmountLabel() {
        return i18n.tc("class.DistributionOrder.countProducts", this.productAmount, { count: this.productAmount });
    }

    get productionStatusLabel() {
        return i18n.t(`class.DistributionOrder.productionStatus.${this.status.production}`);
    }

    get paymentStatusLabel() {
        return i18n.t(`class.DistributionOrder.paymentStatus.${this.status.payment}`);
    }

    get defaultBillingDocument() {
        if (this.billing.reference.credit) {
            return "credit";
        } else if (this.billing.reference.bill) {
            return "bill";
        } else {
            return "proForma";
        }
    }
}

export default DistributionOrder;